import {useMutation, useQueryClient} from '@tanstack/react-query';

import {trustAccountActivityKeys} from '@/features/trust-accounts/hooks/useTrustAccountActivity';
// Direct path, not the feature barrel — the barrel re-exports hooks that import this module back.
import {invalidatePaymentInstructions} from '@/features/trust-accounts/utils/trust-account-invalidations.utils';
import {useApiClient} from '@/hooks';

import {paymentsApi} from '../api';

export function useCancelPaymentInstructionMutation(trustAccountId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentId: string) =>
      paymentsApi.cancelPaymentInstruction(client, trustAccountId, paymentId, crypto.randomUUID()),
    onSuccess: () => {
      // Cancelling can make the buyer deletable again — invalidatePaymentInstructions refreshes `canDelete`.
      invalidatePaymentInstructions(queryClient, trustAccountId);
      queryClient.invalidateQueries({queryKey: trustAccountActivityKeys.tabCounts(trustAccountId)});
      queryClient.invalidateQueries({queryKey: trustAccountActivityKeys.stats(trustAccountId)});
    }
  });
}
